import React from "react"
import { StyledTabLabel } from "./partials"
import { blokType } from "../../types"

export interface TabProps {
  label: string
  content?: blokType[]
  isActive: boolean
  onClick: () => void
}

export const Tab: React.FC<TabProps> = ({ label, onClick, isActive }) => {
  return (
    <StyledTabLabel isActive={isActive} onClick={onClick}>
      {label}
    </StyledTabLabel>
  )
}
